var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Thêm nhóm",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-circle-plus-outline",
        "panel-icon-tone": "success",
        "panel-title": "Thêm nhóm",
        "panel-subtitle": "Chọn nhóm để thêm học sinh vào",
        "confirm-loading": _vm.loadingAddToGroup,
        "confirm-disabled": _vm.listGroupSelect.length === 0,
        "confirm-text": "Xác nhận",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleAddToGroup,
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "el-form",
        { ref: "dataForm", attrs: { "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Chọn thêm nhóm" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sk-u-w-full",
                  attrs: { multiple: "", placeholder: "Chọn nhóm" },
                  model: {
                    value: _vm.listGroupSelect,
                    callback: function ($$v) {
                      _vm.listGroupSelect = $$v
                    },
                    expression: "listGroupSelect",
                  },
                },
                _vm._l(_vm.listGroup, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.nameGroup, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }